document.addEventListener("DOMContentLoaded", () => {
	const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

	const headings = Array.from(document.querySelectorAll(".content-two-thirds h2")).filter(
		() => !prefersReducedMotion
	);
	if (!headings.length) return;

	import("../../../assets/js/gsap.js").then(({ gsap, ScrollTrigger }) => {
		headings.forEach((heading) => {
			// Wrap each word in a span — title field is plain text so regex is safe
			heading.innerHTML = heading.innerHTML.replace(
				/(\S+)/g,
				'<span class="karaoke-word">$1</span>'
			);

			const words = heading.querySelectorAll(".karaoke-word");

			// Start words at the muted color so the reveal animates to the accessible dark color.
			// Without JS the heading inherits its default dark color, keeping contrast passing.
			gsap.set(words, { color: "#9999a1" });

			ScrollTrigger.create({
				trigger: heading,
				// Fire once the bottom edge of the h2 clears the bottom of the viewport
				// (entire heading is fully visible)
				start: "bottom bottom",
				once: true,
				onEnter: () => {
					gsap.to(words, {
						color: "#121212",
						duration: 0.25,
						stagger: 0.15,
						ease: "power1.out",
					});
				},
			});
		});
	});
});
